/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /* ------------------------------------------------------------------
   * Ekenberg - fiks for produktfaner som ikke vises pa oversatte sider
   * ------------------------------------------------------------------
   * Bakgrunn: <tabs-component> slar opp hvert .tab-content-N-element i
   * connectedCallback() og mellomlagrer referansen. Weglot flytter noder
   * i DOM-en mens siden lastes, slik at .tab-content-1 og .tab-content-2
   * havner UTENFOR <tabs-component>. Det gir to feil:
   *   1) Den mellomlagrede referansen blir null -> tabChange() kaster
   *      "Cannot read properties of null" ved klikk.
   *   2) Opprydding av forrige fane bruker this.querySelector(), som ikke
   *      finner blokker som er flyttet ut -> flere faner blir apne samtidig.
   *
   * Fiks: vi pakker inn tabChange() slik at malelementet slas opp pa nytt
   * ved klikk, og rydder bort "current" fra blokker som er flyttet ut.
   * Oppslaget er avgrenset til samme [data-section-id] slik at de to
   * tabs-komponentene pa produktsiden (produktfaner og relaterte
   * produkter) ikke kan plukke hverandres innhold.
   *
   * Pa sider uten Weglot-flytting er dette en ren no-op: alle blokker
   * ligger da inne i komponenten, og original-oppforselen er uendret.
   * theme.js er ikke rort. Lagt inn 27.08.2026.
   * ------------------------------------------------------------------ */
  function patchTabsComponent() {
    var TabsComponent = window.customElements && customElements.get('tabs-component');
    if (!TabsComponent || TabsComponent.prototype.__ekTabFix) return false;

    var proto = TabsComponent.prototype;
    var originalTabChange = proto.tabChange;

    function scopeOf(component) {
      return component.closest('[data-section-id]') || component.parentElement || document;
    }

    function findContent(component, index) {
      return component.querySelector('.tab-content-' + index) ||
             scopeOf(component).querySelector('.tab-content-' + index);
    }

    proto.tabChange = function (tab, target) {
      if (!tab) return;
      var index = tab.getAttribute('data-tab');

      if (!target) target = findContent(this, index);
      if (!target) return;

      // Rydd bort "current" fra innhold som Weglot har flyttet ut av komponenten.
      var links = this.querySelectorAll('[data-tab]');
      for (var i = 0; i < links.length; i++) {
        var otherIndex = links[i].getAttribute('data-tab');
        if (otherIndex === index) continue;
        var other = findContent(this, otherIndex);
        if (other && other !== target && !this.contains(other)) {
          other.classList.remove('current');
        }
      }

      return originalTabChange.call(this, tab, target);
    };

    proto.__ekTabFix = true;
    return true;
  }

  if (!patchTabsComponent() && window.customElements && customElements.whenDefined) {
    customElements.whenDefined('tabs-component').then(patchTabsComponent);
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
